import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

const STALE_FOREVER = { staleTime: Infinity }

export function useRefSkills() {
  return useQuery({
    queryKey: ['ref-skills'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_skills').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefWeapons() {
  return useQuery({
    queryKey: ['ref-weapons'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_weapons').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefArmourMaterials() {
  return useQuery({
    queryKey: ['ref-armour-materials'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_armour_materials').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefOccupations() {
  return useQuery({
    queryKey: ['ref-occupations'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_occupations').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefSpecies() {
  return useQuery({
    queryKey: ['ref-species'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_species').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefSunsigns() {
  return useQuery({
    queryKey: ['ref-sunsigns'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_sunsigns').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefSunsignMods() {
  return useQuery({
    queryKey: ['ref-sunsign-mods'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_skill_sunsign_mods').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefCultures() {
  return useQuery({
    queryKey: ['ref-cultures'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_cultures').select('*')
      if (error) throw error
      return data
    },
  })
}

export function useRefTraits() {
  return useQuery({
    queryKey: ['ref-traits'],
    ...STALE_FOREVER,
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_traits').select('*')
      if (error) throw error
      return data
    },
  })
}
